import { IftaReportState } from '../types';

export const iftaReportsState: IftaReportState = {
  drivers: [],
  reports: [],
  hiddenReports: [],
  isRequestPending: false,
};
